import { Button } from "./ui/button";
import { Target } from "lucide-react";
import { useCallback } from "react";

interface SetBodyFatTargetButtonProps {
  targetPercentage: number;
  disabled: boolean;
  onSetTarget?: (value: number) => void;
}

export const SetBodyFatTargetButton = ({
  targetPercentage,
  disabled,
  onSetTarget,
}: SetBodyFatTargetButtonProps) => {
  const handleSetTarget = useCallback(async () => {
    if (!onSetTarget) {
      return;
    }
    onSetTarget(targetPercentage);
  }, [targetPercentage, onSetTarget]);

  return (
    <Button
      variant="outline"
      size="sm"
      className="gap-2"
      disabled={disabled}
      onClick={handleSetTarget}
    >
      <Target className="w-4 h-4" />
      {disabled ? "Target Set" : "Set as Target"}
    </Button>
  );
};
